export const apiConstants = {
  LOGIN_URL: '/login',
  USER_DETAILS_API: '/user/me',
  AUTH: 'auth',
  LAST_LOGIN: '/last-login',
  TICKETS_LIST_API: '/tickets',
  TICKET_TOTAL_API: '/tickets/getTotal',
  CUSTOMER_ACCESS_MAPPING: '/customerAccessMapping',
  TICKET_IMAGE_LIST_API: '/image',
  EXPORT_DOCUMENTS: '/export-documents',
  USER_API: '/user',
  LIST_USERS: '/list-users',
  PARENT_CHILD_MAPPING: '/user/suppliers',
  CREATE_ADMIN_API: '/user/invite',
  ROLES_LIST_API: '/user-role',
  CUSTOMERS_API: '/tickets/customers',
  SUPPLIER_API: '/supplier',
  EXPORT: '/export',
  SUPPLIER_FILTERS: '/supplier-filters',
  UPDATE_SUPPLIER_PERMISSION_API: 'update-settings',
  GET_USER_PERMISSION_API: '/user-settings',
  SUPPLIER_MANAGEMENT: '/supplier-management',
  SYNC: '/sync',
  SYNC_ADDRESS: '/sync-address',
  ADD_SUPPLIERS: '/addSuppliers',
  MARK_AS_PARENT: '/markAsParent',
  UNASSIGN: '/unassign',
  LOCATIONS: '/locations',
  CHILD_SUPPLIERS: '/child-suppliers',
  LOCATIONS_API: '/tickets/locations',
  SUPPLIERS_API: '/tickets/suppliers',
  COMMODITIES_API: '/tickets/commodities',
  STATUS_LIST_API: '/tickets/statusList',
  TICKET_DETAILS: '/tickets/detail',
  TICKET_EXPORT_CSV: '/tickets/export/csv',
  TICKET_EXPORT_EXCEL: '/tickets/export/excel',
  TICKET_PRINT_PDF: '/tickets/pdf',
  SUPPORT_EMAIL: '/support/mail',
  SUPPORT_LOGIN_REQUEST: '/support/loginRequest',
} as const
